(function () {
  'use strict';

  angular.module('app').component('addGuestToItem', addGuestToItem());

  function addGuestToItem() {
    return {
      bindings: {
        item: '<',
        onSavedItem: '&',
        onCanceledItem: '&',
      },
      controller: AddGuestToItemComponent,
      controllerAs: 'vm',
      templateUrl:
        './app/ajs/bookings/booking-guests/add-guest-to-item/add-guest-to-item.component.html',
    };
  }

  AddGuestToItemComponent.$inject = [
    'CONFIGURATIONS',
    'UtilService',
    'ModalWindowConfirmService',
    'BookingItemService',
  ];

  function AddGuestToItemComponent(
    config,
    UtilService,
    ModalWindowConfirmService,
    BookingItemService
  ) {
    const vm = this;

    let modalParams = {
      mode: 'danger',
      preventModalClose: true,
      title: 'CHECK_IN_IS_NOT_ALLOW_HAS_CHECKED_IN',
      confirmButtonLabel: 'ACCEPT',
    };

    vm.UtilService = new UtilService(vm);
    vm.dateDisplay = config.DATE_DISPLAY;
    vm.hourDisplay = config.HOUR_DISPLAY;

    // Methods
    vm.saveAddGuestToBookingItem = saveAddGuestToBookingItem;
    vm.checkAllBookingItems = checkAllBookingItems;
    vm.checkBookingItem = checkBookingItem;
    vm.cancel = cancel;

    vm.$onInit = function () {
      vm.guest = vm.item.guest;
      vm.guestName = `${vm.guest.name} ${vm.guest.last_name}`;
      vm.bookingItems = vm.item.booking.booking_items;

      selectedItems(vm.bookingItems);
    };

    function checkAllBookingItems() {
      let hasItems = false;
      vm.bookingItems.forEach((item) => {
        if (item.based_on_service_items) {
          item.booking_item_service_items.forEach((service_item) => {
            let result = hasCheckedIn(service_item.id);
            if (!vm.allBookingItemsChecked && result) {
              service_item.selected = !vm.allBookingItemsChecked;
            } else {
              service_item.selected = vm.allBookingItemsChecked;
            }

            hasItems = result ? result : hasItems;
          });
        } else {
          let result = hasCheckedIn(item.id);
          if (!vm.allBookingItemsChecked && result) {
            item.selected = !vm.allBookingItemsChecked;
          } else {
            item.selected = vm.allBookingItemsChecked;
          }

          hasItems = result ? result : hasItems;
        }
      });

      if (hasItems && !vm.allBookingItemsChecked) ModalWindowConfirmService.open(modalParams);
      validateCheckedBookingItems();
    }

    function hasCheckedIn(id) {
      return (
        vm.guest.checked_in_service_items.includes(id) ||
        vm.guest.checked_in_booking_items.includes(id)
      );
    }

    function checkBookingItem(isChecked, bookingItem) {
      if (!isChecked && hasCheckedIn(bookingItem.id)) {
        bookingItem.selected = !isChecked;
        ModalWindowConfirmService.open(modalParams);
        return;
      }

      bookingItem.selected = isChecked;

      validateCheckedBookingItems();
    }

    function validateCheckedBookingItems() {
      vm.allBookingItemsChecked = vm.bookingItems.every((item) => {
        if (!item.based_on_service_items) return item.selected === true;
        if (item.based_on_service_items)
          return item.booking_item_service_items.every((service) => service.selected === true);
      });

      addGuestToBookingItem();
    }

    function addGuestToBookingItem(bookingItems = vm.bookingItems, guest = vm.guest) {
      bookingItems.forEach((bookingItem) => {
        if (bookingItem.based_on_service_items) {
          bookingItem.booking_item_service_items.forEach((serviceItem) => {
            let isGuestAdded = serviceItem.guest_ids.includes(guest.id);
            if (serviceItem.selected && !isGuestAdded) {
              serviceItem.guests = serviceItem.guests || [];
              serviceItem.guest_ids.push(guest.id);
            } else if (!serviceItem.selected && isGuestAdded) {
              serviceItem.guest_ids.splice(
                serviceItem.guest_ids.map((id) => id).indexOf(guest.id),
                1
              );
            }
          });
        } else {
          let isGuestAdded = bookingItem.guest_ids.includes(guest.id);
          if (bookingItem.selected && !isGuestAdded) {
            bookingItem.guests = bookingItem.guests || [];
            bookingItem.guest_ids.push(guest.id);
          } else if (!bookingItem.selected && isGuestAdded) {
            bookingItem.guest_ids.splice(
              bookingItem.guest_ids.map((id) => id).indexOf(guest.id),
              1
            );
          }
        }
      });
    }

    function selectedItems(bookingItems) {
      bookingItems.forEach((bookingItem) => {
        if (bookingItem.based_on_service_items) {
          bookingItem.booking_item_service_items.forEach((serviceItem) => {
            serviceItem.selected = serviceItem.guest_ids.includes(vm.guest.id);
          });
        } else {
          bookingItem.selected = bookingItem.guest_ids.includes(vm.guest.id);
        }
      });

      validateCheckedBookingItems();
    }

    function saveAddGuestToBookingItem() {
      vm.sendingForm = true;
      BookingItemService.addGuestToBookingItem(vm.bookingItems, vm.guest.id).then(function (data) {
        vm.onSavedItem({ item: data.response });

        vm.sendingForm = false;
      });
    }

    function cancel() {
      vm.onCanceledItem();
    }
  }
})();
